"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
const versioned = [{
  minmax: [0, undefined],
  types: {
    Address: 'MultiAddress',
    LookupSource: 'MultiAddress',
    TAssetBalance: 'u128'
  }
}];
var _default = versioned;
exports.default = _default;